<section class="rollen-tab">
    <div class="rollen-toolbar">
        <button type="button" class="create-role-button" (click)="createRolle()">
            <mat-icon fontSet="material-icons-outlined">add</mat-icon>
            Rolle erstellen
        </button>
    </div>

    @if (isLoading()) {
    <div class="roles-grid">
        @for (item of skeletonItems; track $index) {
        <article class="role-card skeleton-card">
            <div class="skeleton skeleton-title"></div>

            <div class="skeleton-chip-row">
                <div class="skeleton skeleton-chip"></div>
                <div class="skeleton skeleton-chip"></div>
            </div>
        </article>
        }
    </div>
    } @else {
    @if (!rollen().length) {
    <div class="no-roles-state">
        <mat-icon fontSet="material-icons-outlined">
            admin_panel_settings
        </mat-icon>

        <h2>Derzeit ist keine Rolle vorhanden.</h2>

        <p>Bitte erstellen Sie zuerst eine Rolle.</p>
    </div>
    } @else {
    <div class="roles-grid">
        @for (rolle of rollen(); track rolle.id) {
        <article class="role-card">
            <div class="role-card-header">
                <div class="role-title">
                    <mat-icon fontSet="material-icons-outlined" class="role-icon">
                        sell
                    </mat-icon>

                    <h2>{{ rolle.name }}</h2>
                </div>

                @if (!isCurrentUserRolle(rolle)) {
                <div class="role-actions">
                    <button type="button" class="icon-action-button" aria-label="Rolle bearbeiten"
                        (click)="editRolle(rolle)">
                        <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
                    </button>

                    <button type="button" class="icon-action-button" aria-label="Rolle löschen"
                        (click)="deleteRolle(rolle)">
                        <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
                    </button>
                </div>
                }
            </div>

            @if (rolle.istAdminRolle) {
            <span class="admin-chip">
                <mat-icon fontSet="material-icons-outlined">shield</mat-icon>
                Administrator
            </span>
            }

            <div class="module-list">
                @if (rolle.module.length === 0) {
                <span class="module-chip module-chip-text">
                    Keine Module
                </span>
                } @else {
                @for (modul of rolle.module; track modul) {
                <span class="module-chip" [class.module-chip-text]="modul === 'Zugriff auf alle Module'">
                    {{ modul }}
                </span>
                }
                }
            </div>
        </article>
        }
    </div>
    }
    }
</section>